import {z} from 'zod';

import {BaseVoidRequestSchema, BaseVoidResponseSchema} from '@dms/api/shared';

export const HyundaiAs1qImportOptionsSchema = z.object({
  material: z.boolean(),
  labourSummarized: z.boolean(),
  labourItemized: z.boolean(),
  sundries: z.boolean(),
  sublets: z.boolean(),
  accessories: z.boolean(),
});

export type HyundaiAs1qImportOptions = z.infer<typeof HyundaiAs1qImportOptionsSchema>;

export const GetHyundaiAs1qUserOptionsApiArgSchema = BaseVoidRequestSchema;

export type GetHyundaiAs1qUserOptionsApiArg = z.infer<typeof GetHyundaiAs1qUserOptionsApiArgSchema>;

export const GetHyundaiAs1qUserOptionsApiResponseSchema = HyundaiAs1qImportOptionsSchema.nullable();

export type GetHyundaiAs1qUserOptionsApiResponse = z.infer<
  typeof GetHyundaiAs1qUserOptionsApiResponseSchema
>;

export const PostHyundaiAs1qRetrieveApiArgSchema = z.object({
  body: z.object({
    serviceCaseId: z.string(),
    serviceOrderId: z.string(),
    options: HyundaiAs1qImportOptionsSchema,
  }),
});

export type PostHyundaiAs1qRetrieveApiArg = z.infer<typeof PostHyundaiAs1qRetrieveApiArgSchema>;

export const PostHyundaiAs1qRetrieveApiResponseSchema = BaseVoidResponseSchema;

export type PostHyundaiAs1qRetrieveApiResponse = z.infer<
  typeof PostHyundaiAs1qRetrieveApiResponseSchema
>;
